import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f853a46c")

_pushScopeId("data-v-f853a46c")
const _hoisted_1 = { class: "w-full flex flex-col gap-4" }
const _hoisted_2 = { class: "w-full flex flex-row gap-4" }
const _hoisted_3 = { class: "w-full flex-1" }
const _hoisted_4 = { class: "w-full flex-1" }
const _hoisted_5 = { class: "w-full flex-1" }
const _hoisted_6 = { class: "w-full flex flex-row gap-4" }
const _hoisted_7 = { class: "w-full flex-1" }
const _hoisted_8 = { class: "w-full flex-1" }
const _hoisted_9 = { class: "w-full flex-1" }
const _hoisted_10 = {
  class: "w-full flex flex-row gap-4 flex-1 client-address-input",
  style: {"flex":"1"}
}
const _hoisted_11 = {
  class: "flex flex-col gap-3",
  style: {"flex":"1"}
}
const _hoisted_12 = { class: "mt-3" }
const _hoisted_13 = { class: "text-gray-lp-300 font-semibold ml-2" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", {
  class: "flex flex-col",
  style: {"flex":"1"}
}, null, -1)
const _hoisted_15 = {
  class: "flex flex-row gap-4 flex-1 w-full",
  style: {"flex":"1"}
}
const _hoisted_16 = /*#__PURE__*/_createVNode("div", {
  class: "flex flex-col",
  style: {"flex":"1"}
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("div", {
  class: "flex flex-col",
  style: {"flex":"1"}
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Title = _resolveComponent("Title")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_managing_country_field = _resolveComponent("managing-country-field")!

  return (_openBlock(), _createBlock("section", null, [
    _createVNode(_component_Title, {
      class: "mb-4",
      fontSize: 20,
      label: _ctx.$t('clientManagement.registrationForm.parent.title')
    }, null, 8, ["label"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_DataWrapper, {
            asterisk: "",
            label: _ctx.$t('clientManagement.registrationForm.parent.parentClientName'),
            fontSize: 14
          }, {
            default: _withId(() => [
              _createVNode(_component_LpInput, {
                placeholder: _ctx.$t('clientManagement.registrationForm.parent.enterClientName'),
                modelValue: _ctx.formModel.companyName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formModel.companyName = $event))
              }, null, 8, ["placeholder", "modelValue"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_DataWrapper, {
            asterisk: "",
            label: _ctx.$t('clientManagement.managementList.columns.alias'),
            fontSize: 14
          }, {
            default: _withId(() => [
              _createVNode(_component_LpInput, {
                placeholder: _ctx.$t('clientManagement.registrationForm.parent.enterAlias'),
                modelValue: _ctx.formModel.companyAlias,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formModel.companyAlias = $event)),
                error: _ctx.formErrorModel.alias,
                errorCaption: _ctx.formModel.companyAlias && _ctx.formModel.companyAlias.length > 3 ? _ctx.$t('clientManagement.registrationForm.parent.max100Characters').toString() : _ctx.$t('clientManagement.registrationForm.parent.min3Characters').toString(),
                isUppercase: "",
                onChange: _ctx.validateAlias,
                id: "field_client_alias_client_registration_parent"
              }, null, 8, ["placeholder", "modelValue", "error", "errorCaption", "onChange"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_DataWrapper, {
            asterisk: "",
            label: _ctx.$t('clientManagement.managementDetail.clientCategory'),
            fontSize: 14
          }, {
            default: _withId(() => [
              _createVNode(_component_CustomDropdown, {
                class: "mt-2",
                placeholder: _ctx.$t('clientManagement.registrationForm.parent.selectParentClientCategory'),
                customValueStyle: "text-sm",
                customOptionStyle: "text-sm",
                options: _ctx.clientCategoryList,
                selectedItem: _ctx.formModel.clientCategory.name,
                modelValue: _ctx.formModel.clientCategory,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formModel.clientCategory = $event))
              }, null, 8, ["placeholder", "options", "selectedItem", "modelValue"])
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_DataWrapper, {
            asterisk: "",
            label: _ctx.$t('clientManagement.managementDetail.companySize'),
            fontSize: 14
          }, {
            default: _withId(() => [
              _createVNode(_component_CustomDropdown, {
                class: "mt-2",
                placeholder: _ctx.$t('clientManagement.registrationForm.parent.selectParentCompanySize'),
                customValueStyle: "text-sm",
                customOptionStyle: "text-sm",
                options: _ctx.companySizeList,
                selectedItem: _ctx.formModel.companySize,
                modelValue: _ctx.formModel.companySize,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formModel.companySize = $event))
              }, null, 8, ["placeholder", "options", "selectedItem", "modelValue"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('clientManagement.registrationForm.contact.phone'),
            fontSize: 14,
            asterisk: "",
            style: {"flex":"1"}
          }, {
            default: _withId(() => [
              _createVNode(_component_LpInput, {
                placeholder: "Contoh: 8123456789012",
                prefix: _ctx.prefix,
                format: _ctx.formatNumber,
                debounce: 500,
                error: _ctx.formErrorModel.phone,
                maxLength: "12",
                errorCaption: "Masukan No. Telepon dengan benar",
                modelValue: _ctx.formModel.phone,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formModel.phone = $event)),
                onChange: _ctx.validatePhone
              }, null, 8, ["prefix", "format", "error", "modelValue", "onChange"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('clientManagement.managementDetail.email'),
            fontSize: 14,
            asterisk: ""
          }, {
            default: _withId(() => [
              _createVNode(_component_LpInput, {
                placeholder: _ctx.$t('clientManagement.registrationForm.contact.emailExample'),
                modelValue: _ctx.formModel.email,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formModel.email = $event)),
                error: _ctx.formErrorModel.email,
                errorCaption: _ctx.$t('clientManagement.registrationForm.contact.invalidEmail'),
                onChange: _ctx.validateEmail
              }, null, 8, ["placeholder", "modelValue", "error", "errorCaption", "onChange"])
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('clientManagement.managementDetail.address'),
          fontSize: 14,
          asterisk: "",
          style: {"flex":"1"}
        }, {
          default: _withId(() => [
            _createVNode(_component_LpInput, {
              class: "w-full",
              type: "textarea",
              placeholder: _ctx.$t('clientManagement.registrationForm.parent.enterParentClientAddress'),
              modelValue: _ctx.formModel.address,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formModel.address = $event))
            }, null, 8, ["placeholder", "modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode("div", _hoisted_11, [
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('clientManagement.managementDetail.districtCity'),
            fontSize: 14,
            asterisk: ""
          }, {
            default: _withId(() => [
              _createVNode(_component_SelectSearch, {
                class: "mt-2",
                placeholder: _ctx.$t('clientManagement.registrationForm.parent.typeAndSelectDistrictCityParent'),
                customValueStyle: "text-sm",
                keyValue: "id",
                isLoading: _ctx.loadingDistrictList,
                options: _ctx.districtList,
                modelValue: _ctx.formModel.district,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formModel.district = $event)),
                onFilter: _ctx.fetchDistrictList,
                onChange: _ctx.onChangeDistrict
              }, null, 8, ["placeholder", "isLoading", "options", "modelValue", "onFilter", "onChange"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('clientManagement.managementDetail.needAssessmentChange'),
            asterisk: "",
            fontSize: 14,
            style: {"flex":"1"}
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_12, [
                _createVNode(_component_Toggle, {
                  id: _ctx.routeTypeName === 'edit-client-parent' ? 'checkbox_assesment_edit_client_parent' : 'checkbox_assesment_create_client_parent',
                  modelValue: _ctx.formModel.isNeedAssessment,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formModel.isNeedAssessment = $event)),
                  customLabel: true
                }, {
                  "custom-label": _withId(() => [
                    _createVNode("div", _hoisted_13, _toDisplayString(_ctx.formModel.isNeedAssessment ? _ctx.$t("clientManagement.managementDetail.yes") : _ctx.$t("clientManagement.managementDetail.no")), 1)
                  ]),
                  _: 1
                }, 8, ["id", "modelValue"])
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _hoisted_14
      ]),
      _createVNode("div", _hoisted_15, [
        _createVNode(_component_managing_country_field, {
          options: _ctx.managingCountryOptions,
          "model-value": _ctx.formModel.managingCountry,
          "onUpdate:modelValue": _ctx.onSetManagingCountry
        }, null, 8, ["options", "model-value", "onUpdate:modelValue"]),
        _hoisted_16,
        _hoisted_17
      ])
    ])
  ]))
})